import axios from 'axios';
import { UserRegistrationForm } from '../../investors/models/userModel';

const loadAbort = () => {
    return new AbortController();
};

export const createInternalUserEndpoint = (
    form: UserRegistrationForm,
    token: string = '',
) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'post',
                url: `${urlService}/user/v1/admin/internal-users`,
                data: JSON.stringify(form),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
};

export const getInternalUsersEndpoint = (token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'get',
                url: `${urlService}/user/v1/admin/internal-users`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const deactivateInternalUserEndpoint = (userId: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'delete',
                url: `${urlService}/user/v1/admin/internal-user/${userId}/deactivate`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const activateInternalUserEndpoint = (userId: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/user/v1/admin/internal-user/${userId}/activate`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const updateInternalUserPasswordEndpoint = (userId: string, newPassword: string, token: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/user/v1/admin/internal-user/${userId}/change-password`,
                data: JSON.stringify({ password: newPassword }),
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}